import { toast } from "react-toastify";

import { getAccessToken, setAccessToken } from "./storage";

export const SNCR_AUTH_POPUP_NAME = "sncr-govbr-auth";

const SNCR_AUTH_CHANNEL = "sncr-auth";

const AUTH_UPDATED_EVENT = "sncr-auth-updated";

const CONNECT_ERROR_MESSAGE =
  "Não foi possível conectar ao SNCR. O session_id expira em ~30s e é de uso único.";

type SncrAuthPopupMessage = {
  type: "sncr-auth";
  result: "success" | "error";
  accessToken?: string;
};

let parentChannel: BroadcastChannel | null = null;

export function isSncrAuthPopup(): boolean {
  return window.name === SNCR_AUTH_POPUP_NAME;
}

export function ensureSncrAuthPopupListener(): void {
  if (isSncrAuthPopup()) return;
  if (parentChannel || typeof BroadcastChannel === "undefined") return;

  parentChannel = new BroadcastChannel(SNCR_AUTH_CHANNEL);
  parentChannel.onmessage = (event: MessageEvent<SncrAuthPopupMessage>) => {
    const data = event.data;
    if (!data || data.type !== "sncr-auth") return;

    if (data.result === "success" && data.accessToken) {
      setAccessToken(data.accessToken);
      toast.success("Conectado ao SNCR com sucesso.");
    } else if (data.result === "error") {
      toast.error(CONNECT_ERROR_MESSAGE);
    } else {
      return;
    }

    window.dispatchEvent(new CustomEvent(AUTH_UPDATED_EVENT));
  };
}

export function subscribeSncrAuthUpdated(onUpdated: () => void): () => void {
  if (isSncrAuthPopup()) return () => undefined;

  const handler = () => onUpdated();
  window.addEventListener(AUTH_UPDATED_EVENT, handler);
  return () => window.removeEventListener(AUTH_UPDATED_EVENT, handler);
}

export function openSncrAuthPopup(loginUrl: string): Window | null {
  const width = 520;
  const height = 760;
  const left = Math.max(
    0,
    (window.screenX ?? 0) + (window.outerWidth - width) / 2,
  );
  const top = Math.max(
    0,
    (window.screenY ?? 0) + (window.outerHeight - height) / 2,
  );
  const features = [
    "popup=yes",
    `width=${Math.round(width)}`,
    `height=${Math.round(height)}`,
    `left=${Math.round(left)}`,
    `top=${Math.round(top)}`,
  ].join(",");

  const popup = window.open(loginUrl, SNCR_AUTH_POPUP_NAME, features);
  popup?.focus();
  return popup;
}

export function notifySncrAuthPopup(result: "success" | "error"): void {
  if (!isSncrAuthPopup()) return;

  const accessToken = result === "success" ? getAccessToken() : null;
  const message: SncrAuthPopupMessage = {
    type: "sncr-auth",
    result: result === "success" && accessToken ? "success" : "error",
    ...(accessToken ? { accessToken } : {}),
  };

  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel(SNCR_AUTH_CHANNEL);
    channel.postMessage(message);
    channel.close();
  }

  window.setTimeout(() => {
    window.close();
  }, 100);
}
